export async function getDominantColor(imageUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous'; // クロスオリジンの画像を扱う場合に必要
    image.src = imageUrl;

    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = image.width;
      canvas.height = image.height;

      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      const colorCount = {};

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const alpha = data[i + 3];

        // Skip fully transparent pixels
        if (alpha === 0) continue;

        let color = `${r},${g},${b}`;

        if (colorCount[color]) {
          colorCount[color].count++;
        } else {
          colorCount[color] = { count: 1, r: r, g: g, b: b };
        }
      }

      const maxCountColor = Object.values(colorCount).reduce(
        (max, current) => {
          return current.count > max.count ? current : max;
        },
        { count: 0, r: 0, g: 0, b: 0 },
      );

      // r,g,bの値を3d空間座標として、colorsの中で最も近い色を探す
      const nearestColor = colors.reduce((min, current) => {
        const currentDistance = Math.sqrt(
          Math.pow(current.r - maxCountColor.r, 2) +
            Math.pow(current.g - maxCountColor.g, 2) +
            Math.pow(current.b - maxCountColor.b, 2),
        );
        const minDistance = Math.sqrt(
          Math.pow(min.r - maxCountColor.r, 2) +
            Math.pow(min.g - maxCountColor.g, 2) +
            Math.pow(min.b - maxCountColor.b, 2),
        );
        return currentDistance < minDistance ? current : min;
      });

      resolve(`rgb(${nearestColor.r},${nearestColor.g},${nearestColor.b})`);
    };

    image.onerror = () => {
      reject(new Error('Failed to load image'));
    };
  });
}

const colors = [
  { r: 161, g: 103, b: 100 },
  { r: 147, g: 80, b: 92 },
  { r: 173, g: 115, b: 88 },
  { r: 171, g: 101, b: 91 },
  { r: 175, g: 134, b: 81 },
  { r: 126, g: 132, b: 64 },
  { r: 113, g: 137, b: 125 },
  { r: 83, g: 124, b: 130 },
  { r: 102, g: 151, b: 175 },
  { r: 101, g: 108, b: 152 },
  { r: 65, g: 87, b: 118 },
  { r: 135, g: 96, b: 144 },
  { r: 127, g: 109, b: 168 },
  { r: 167, g: 103, b: 131 },
  { r: 148, g: 104, b: 119 },
  { r: 83, g: 83, b: 83 },
];
